{
  "w": 32,
  "h": 48,
  "rows": [
    "................................",
    "................G...............",
    "................G...............",
    "................G...............",
    "................G...............",
    "...............GGG..............",
    ".............WWWGWWW............",
    ".............W.GGG.W............",
    "..............GGGGG.............",
    "..............GGGGG.............",
    "..............GGGGG.............",
    "............WWWWWWWWW...........",
    "............WGGGGGGGW...........",
    ".............GGGGGGG............",
    "............GGgGGGgGG...........",
    "............ggggggggg...........",
    "............ggggggggg...........",
    "..........WWWWWWGWWWWWW.........",
    "..........WGGGGGGGGGGGW.........",
    "...........GGGgGGGgGGG..........",
    "..........ggggggggggggg.........",
    "..........ggggggggggggg.........",
    ".........WWWWWWWGWWWWWWW........",
    ".........WGGGGGGGGGGGGGW........",
    "........GGGGGGgGGGgGGGGGG.......",
    "........ggggggggggggggggg.......",
    ".......ggggggggggggggggggg......",
    ".......WWWWWWWWWWWWWWWWWWW......",
    ".......WGGGGGGGGGGGGGGGGGW......",
    ".......GGGGGGGgGGGgGGGGGGG......",
    "......ggggggggggggggggggggg.....",
    ".....ggggggggggggggggggggggg....",
    "......GGGGGGGGGGGGGGGGGGGGG.....",
    ".....GGGGGGGGGGGGGGGGGGGGGGG....",
    "....GGGGGGGGGGgGGGgGGGGGGGGGG...",
    "...ggggggggggggggggggggggggggg..",
    "..ggggggggggggggggggggggggggggg.",
    "...............RK...............",
    "...............RK...............",
    "...............RK...............",
    "...............RK...............",
    "...............RK...............",
    "...............RK...............",
    "...............RK...............",
    "...............RK...............",
    "...............RK...............",
    "...............RK...............",
    "...........WWWWWWWWWWW.........."
  ],
  "legend": {
    "K": "C.BLACK",
    "G": "C.B_GREEN",
    "g": "C.GREEN",
    "R": "C.RED",
    "W": "C.B_WHITE"
  }
}
